const state = {
    siteSettings: null,
    searchText: null,
    gamesData: null,
    domainName: (window.location.hostname.split('.').slice(-2)[0] ? window.location.hostname.split('.').slice(-2)[0].toUpperCase() : ''),
    clickBetValue: null,
    isClickBetOn: false,
    favouriteGames:null,
    globalLoader:false,
    notification:0,
    languagesData:null,
    balExpDisplay:[
        'balance',
        'exposure'
    ],
    languageSelected:null,
    menuShow:true,
    siteVersion:null,
    underMaintenance:null,
    sports_list:null,
    successMsg: null,
    errorMsg: null,
    casinoProviders: null,
    userIdList: [],
    bonusData: [],
    toggleFormTypeFunction: null,
    defaultPhoneIndex: 0,
    userTransactionStakes: null,
    
    androidclose : false,
};
const getters = {
    siteSettings: state => state?.siteSettings,
    searchText: state => state?.searchText,
    gamesData: state => state?.gamesData,
    languagesData: state => state?.languagesData,
    languageSelected: state => state?.languageSelected,
    domainName: state => state?.domainName,
    clickBetValue: state => state?.clickBetValue,
    clickBetActive: state => state?.clickBetValue?.find(item => item.isSelected) ?? false,
    isClickBetOn: state => state?.isClickBetOn,
    favouriteGames:state => state?.favouriteGames,
    globalLoader:state => state?.globalLoader,
    getNotification: state => state?.notification,
    getBalExpDisplay: state => state?.balExpDisplay,
    getRecommendedMatch: state => state?.recommendedMatch,
    menuShow: state => state?.menuShow,
    siteVersion: state => state?.siteVersion,
    underMaintenance: state => state?.underMaintenance,
    sports_list: state => state?.sports_list,
    successMsg: state => state?.successMsg,
    errorMsg: state => state?.errorMsg,
    casinoProviders: state => state?.casinoProviders,
    userIdList: state => state?.userIdList,
    bonusData: state => state?.bonusData,
    toggleFormTypeFunction: state => state?.toggleFormTypeFunction,
    defaultPhoneIndex: state => state?.defaultPhoneIndex,
    userTransactionStakes: state => state?.userTransactionStakes,
    androidclose: state => state?.androidclose,
};
const actions = {
    setSettings({ commit }, siteSettings) {
        commit('setSettings', siteSettings);
    },
    setSearchText({ commit }, searchText) {
        commit('setSearchText', searchText);
    },
    setLanguagesData({ commit }, languagesData) {
        commit('setLanguagesData', languagesData);
    },
    setLanguageSelected({ commit }, languageSelected) {
        commit('setLanguageSelected', languageSelected);
    },
    setGamesData({ commit }, gamesData) {
        commit('setGamesData', gamesData);
    },
    setClickBetValue({ commit }, clickBetValue) {
        commit('setClickBetValue', clickBetValue);
    },
    setIsClickBetOn({ commit }, isClickBetOn) {
        commit('setIsClickBetOn', isClickBetOn);
    },
    setFavouriteGames({ commit }, favouriteGames) {
        commit('setFavouriteGames', favouriteGames);
    },
    setGlobalLoader({ commit }, globalLoader) {
        commit('setGlobalLoader', globalLoader);
    },
    setNotification({ commit }, notification) {
        commit('setNotification', notification);
    },
    setBalExpDisplay({ commit }, balExpDisplay) {
        commit('setBalExpDisplay', balExpDisplay);
    },
    setRecommendedMatch({ commit }, RecommendedMatch) {
        commit('setRecommendedMatch', RecommendedMatch);
    },
    setMenuShow({ commit }, menuShow) {
        commit('setMenuShow', menuShow);
    },
    setSiteVersion({ commit }, siteVersion) {
        commit('setSiteVersion', siteVersion);
    },
    setUnderMaintenance({ commit }, underMaintenance) {
        commit('setUnderMaintenance', underMaintenance);
    },
    setSportsList({ commit }, sports_list) {
        commit('setSportsList', sports_list);
    },
    showSuccessModal({ commit }, message) {
        commit('showSuccessModal', message);
        setTimeout(() => {
            commit('showSuccessModal', null);
        }, 2000);
    },
    showErrorModal({ commit }, message) {
        commit('showErrorModal', message);
        setTimeout(() => {
            commit('showErrorModal', null);
        }, 2000);
    },
    setCasinoProviders({ commit }, casinoProviders){
        commit('setCasinoProviders', casinoProviders);
    },
    setUserIdList({ commit }, userIdList) {
        commit('setUserIdList', userIdList);
    },
    setBonusData({ commit }, bonusData) {
        commit('setBonusData', bonusData);
    },
    setToggleFormTypeFunction({ commit }, fn) {
        commit('setToggleFormTypeFunction', fn);
    },
    triggerToggleFormType({ state }, payload = null) {
        if (typeof state.toggleFormTypeFunction === 'function') {
            state.toggleFormTypeFunction(payload);
        }
    },
    setDefaultPhoneIndex({ commit }, index) {
        commit('setDefaultPhoneIndex', index);
    },
    setDefaultPhoneIndexFromSettings({ commit, state }) {
        const list = state.siteSettings?.country_code_list || [];
        const code = state.siteSettings?.country_code;
        let index = list.findIndex(c => c.phonecode == code);
        if (index === -1) {
            index = 0;
        }
        commit('setDefaultPhoneIndex', index);
    },
    setUserTransactionStakes({ commit }, userTransactionStakes) {
        commit('setUserTransactionStakes', userTransactionStakes);
    },
    Setandroidclose({ commit }, androidclose) {
        commit('Setandroidclose', androidclose);
    },
};
const mutations = {
    setSettings(state, siteSettings) {
        state.siteSettings = siteSettings
    },
    setSearchText(state, searchText) {
        state.searchText = searchText;
    },
    setLanguagesData(state, languagesData) {
        state.languagesData = languagesData;
    },
    setLanguageSelected(state, languageSelected) {
        state.languageSelected = languageSelected;
    },
    setGamesData(state, gamesData) {
        state.gamesData = gamesData;;
    },
    setClickBetValue(state, clickBetValue) {
        state.clickBetValue = clickBetValue;
    },
    setIsClickBetOn(state, isClickBetOn) {
        state.isClickBetOn = isClickBetOn;
    },
    setFavouriteGames(state, favouriteGames) {
        state.favouriteGames = favouriteGames;
    },
    setGlobalLoader(state, globalLoader) {
        if(globalLoader){
            document.body.classList.add('hideScroll');
        }else{
            document.body.classList.remove('hideScroll');
        }
        state.globalLoader = globalLoader;
    },    
    setNotification(state) {
        state.notification = state.notification+1;
    },
    setBalExpDisplay(state, balExpDisplay) {
        state.balExpDisplay = balExpDisplay;
    },
    setRecommendedMatch(state, RecommendedMatch) {
        state.recommendedMatch = RecommendedMatch;
    },
    setMenuShow(state, menuShow) {
        state.menuShow = menuShow;
    },
    setSiteVersion(state, siteVersion) {
        state.siteVersion = siteVersion;
    },
    setUnderMaintenance(state, underMaintenance) {
        state.underMaintenance = underMaintenance;
    },
    setSportsList(state, sports_list) {
        state.sports_list = sports_list;
    },
    showSuccessModal(state, message) {
        state.successMsg = message
    },
    showErrorModal(state, message) {
        state.errorMsg = message
    },
    setCasinoProviders(state, casinoProviders){
        state.casinoProviders = casinoProviders
    },
    setUserIdList(state, userIdList) {
        if (!state.userIdList) {
            state.userIdList = []; // Initialize as an empty array if null/undefined
        }
        if (!state.userIdList.includes(userIdList)) {
            state.userIdList.push(userIdList);
        }
    },
    setBonusData(state, bonusData) {
        state.bonusData = bonusData;
    },
    setToggleFormTypeFunction(state, fn) {
        state.toggleFormTypeFunction = fn;
    },
    setDefaultPhoneIndex(state, index) {
        state.defaultPhoneIndex = index;
    },
    setUserTransactionStakes(state, userTransactionStakes) {
        state.userTransactionStakes = userTransactionStakes;
    },
    Setandroidclose(state, androidclose) {
        state.androidclose = androidclose;
    },

};
export default {
    state,
    getters,
    actions,
    mutations
};